import { useState } from 'react';

import { useDispatch } from 'react-redux';

import Analytics from '@web-solutions/module-analytics';

import { EVENT_ACTION } from 'core/constants/general';
import { setIsLoading } from 'core/upsale/store';

interface UseErrorProps {
  category: string;
  analyticsInfo: any;
  activeProduct: any;
  onClose?: () => void;
  handleShowPaymentPopup: () => void;
}

export const useError = ({
  category,
  analyticsInfo,
  activeProduct,
  onClose,
  handleShowPaymentPopup,
}: UseErrorProps) => {
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorCode, setErrorCode] = useState();
  const dispatch = useDispatch();

  const handleCloseErrorPopup = () => {
    Analytics.trackEvent(`${category}_error_popup`, EVENT_ACTION.CLOSE, {
      ...analyticsInfo,
      currency: activeProduct?.currency,
      amount: activeProduct?.amount,
    });
    setIsErrorModalOpen(false);
    onClose && onClose();
    dispatch(setIsLoading(false));
  };

  const handleSubmitErrorPopup = () => {
    Analytics.trackEvent(category, 'retry', {
      product: activeProduct?.id,
      ...analyticsInfo,
      currency: activeProduct?.currency,
      amount: activeProduct?.amount,
    });
    setIsErrorModalOpen(false);
    handleShowPaymentPopup();
    dispatch(setIsLoading(false));
  };

  return {
    isErrorModalOpen,
    errorCode,
    setIsErrorModalOpen,
    setErrorCode,
    handleCloseErrorPopup,
    handleSubmitErrorPopup,
  };
};
